import * as React from "react";
import { ServiceContext } from "../../context/ServiceContext";
import { FeatureAppConfirmationLayer, } from "./FeatureAppConfirmationLayer";
import { getEnvName } from "../../utils/getEnvName";
import { getChanges, getTicketId, } from "./RegisterFeatureAppComponent";
import { useRegisterFeatureAppConfigurations } from "./useRegisterFeatureAppConfigurations";
import { useNotifyFaOscar } from "./useNotifyOscar";
import { useLogger } from "../../logger/useLogger";
import { shortenErrorMsg } from "../../utils/errorUtils";
const createFeatureAppConfiguration = (change, appStoreAppId) => {
    return {
        path: change.path,
        baseUrl: change.newVersion.baseUrl,
        url: change.newVersion.url,
        ssrUrl: change.newVersion.ssrUrl,
        schema: change.newVersion.schema,
        team: change.newVersion.team,
        version: change.newVersion.version,
        css: change.newVersion.css?.map(({ href, media }) => ({ href, media })),
        appStoreAppId,
    };
};
export const registerFeatureAppAction = (layerManager, releases, configurations, jiraTransitions, headline, name, reload, appStoreAppId) => (env, version) => {
    const chosenReleaseVersion = releases.filter((r) => r.version === version);
    const release = chosenReleaseVersion.length === 1 ? chosenReleaseVersion[0] : undefined;
    if (!release) {
        return;
    }
    // get all changes for the chosen release (could effect multiple feature apps)
    const changes = release ? getChanges(configurations, env, release) : [];
    // jira transition executed for the registration
    const jiraTransition = {
        ticketId: getTicketId(release),
        ...(jiraTransitions[env] || {}),
    };
    layerManager.openAlert(React.createElement(LayerContent, { name: name, env: env, version: version, changes: changes, jiraTransition: jiraTransition, headline: headline, reload: reload, appStoreAppId: appStoreAppId }));
};
const LayerContent = (props) => {
    const { name, env, version, changes, jiraTransition, headline, reload, appStoreAppId, } = props;
    const { ticketId, transitionId, comment } = jiraTransition;
    const envName = getEnvName(env);
    const layerManager = React.useContext(ServiceContext).layerManager;
    // create configuration to be submitted
    const faConfigsToSubmit = changes.map((change) => createFeatureAppConfiguration(change, appStoreAppId));
    // register function
    const register = useRegisterFeatureAppConfigurations(faConfigsToSubmit, env);
    const notifyOscar = useNotifyFaOscar(name, env, version, ticketId, transitionId, comment);
    const httpLogger = useLogger();
    const handleConfirm = async () => {
        const startTime = Date.now();
        try {
            layerManager.closeAlert();
            layerManager.openSpinner();
            httpLogger.info(`registering fa ${name}`);
            const data = await register();
            const response = data.data?.registerFeatureAppConfigurations;
            if (!response?.success) {
                httpLogger.error(`failed registering fa ${name}`, response?.msg);
                layerManager.closeSpinner();
                layerManager.openError("Technical Error", shortenErrorMsg(response?.msg));
                return;
            }
            try {
                await notifyOscar();
            }
            catch (e) {
                httpLogger.error(`failed oscar when registering fa ${name}`);
                console.warn("failed to notify OSCAR", e);
            }
            // TODO:
            reload(env, version, faConfigsToSubmit.map((f) => f.path));
        }
        catch (e) {
            httpLogger.error(`failed to register fa ${name}`, e);
            layerManager.closeSpinner();
            layerManager.openError("Technical Error", shortenErrorMsg(e instanceof Error ? e.message : String(e)));
            return;
        }
        const endTime = Date.now();
        const seconds = (endTime - startTime) / 1000;
        httpLogger.info(`successfully registered fa ${name} after ${seconds}s`);
        layerManager.closeSpinner();
    };
    const handleCancel = () => {
        layerManager.closeAlert();
    };
    return (React.createElement(FeatureAppConfirmationLayer, { name: headline, changes: changes, headline: `Registration of ${version} ${name} on ${envName}`, handleCancel: handleCancel, handleConfirm: handleConfirm }));
};
